import { ClinicPimsIntegrationType } from 'shared/types/graphql';
import {
  IntegrationSystemDisplayNameType,
  integrationSystemDisplayName,
  IntegrationSystemName,
} from '../types/IntegrationSystem';

export const getIntegrationDisplayName = (
  integrationType?: ClinicPimsIntegrationType,
  systemName?: IntegrationSystemName | null,
): IntegrationSystemDisplayNameType => {
  if (!integrationType) return integrationSystemDisplayName.PIMS;

  switch (integrationType) {
    case ClinicPimsIntegrationType.Neo:
      return integrationSystemDisplayName.NEO;
    case ClinicPimsIntegrationType.Vetter:
      return integrationSystemDisplayName.VETTER;
    case ClinicPimsIntegrationType.Ezyvet:
      return integrationSystemDisplayName.EZYVET;
    case ClinicPimsIntegrationType.Datapoint:
      return integrationSystemDisplayName.CORNERSTONE;
    case ClinicPimsIntegrationType.Instinct:
      return integrationSystemDisplayName.INSTINCT;
    case ClinicPimsIntegrationType.Vetdata:
      if (!systemName) {
        return integrationSystemDisplayName.PIMS;
      }
      return integrationSystemDisplayName[systemName];
    case ClinicPimsIntegrationType.SyncVet:
      if (!systemName) {
        return integrationSystemDisplayName.PIMS;
      }
      return integrationSystemDisplayName[systemName];
    default:
      return integrationSystemDisplayName.PIMS;
  }
};
